import { AnimatePresence, motion } from "framer-motion";
import { X, MessageSquareText } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { useQuote } from "@/context/QuoteContext";
import QuoteForm from "@/components/QuoteForm";
import { smsLink, waLink, DEFAULT_MSG } from "@/constants/site";

const QuoteModal = () => {
  const { open, service, closeQuote } = useQuote();
  const msg = service ? service.msg : DEFAULT_MSG;

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center" data-testid="quote-modal">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeQuote}
            className="absolute inset-0 bg-black/75 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 60 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            className="relative w-full max-w-lg max-h-[92vh] overflow-y-auto bg-charcoal border border-white/10 p-6 sm:p-8"
          >
            <button
              onClick={closeQuote}
              data-testid="quote-modal-close-button"
              className="absolute right-4 top-4 inline-flex h-9 w-9 items-center justify-center border border-white/15 text-zinc-400 transition-colors hover:text-white"
              aria-label="Close"
            >
              <X className="h-4 w-4" />
            </button>

            <p className="font-mono text-xs tracking-[0.3em] text-emergency uppercase">Quick Dispatch</p>
            <h3 className="mt-2 font-display text-2xl sm:text-3xl font-black uppercase text-white leading-tight">
              {service ? service.label : "Request a Quote"}
            </h3>

            <div className="mt-5 grid grid-cols-2 gap-3">
              <a href={smsLink(msg)} data-testid="quote-modal-sms-button" className="flex items-center justify-center gap-2 border border-white/20 py-3 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:border-emergency hover:text-emergency">
                <MessageSquareText className="h-4 w-4" /> Text Request
              </a>
              <a href={waLink(msg)} target="_blank" rel="noopener noreferrer" data-testid="quote-modal-whatsapp-button" className="flex items-center justify-center gap-2 bg-dispatch py-3 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-dispatch-dark">
                <FaWhatsapp className="h-4 w-4" /> WhatsApp
              </a>
            </div>
            <p className="mt-2 text-center font-mono text-[10px] tracking-[0.2em] text-zinc-500 uppercase">
              Pre-filled message — just add your location
            </p>

            <div className="my-6 flex items-center gap-4">
              <span className="h-px flex-1 bg-white/10" />
              <span className="font-mono text-[10px] tracking-[0.25em] text-zinc-500 uppercase">or send details</span>
              <span className="h-px flex-1 bg-white/10" />
            </div>

            <QuoteForm initialService={service?.label} />
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default QuoteModal;
